/* Tour step-key state
   --------------------
   Holds the live "current step key" of the guided tour as a module-
   scoped value, so non-tour components (like AddCustomerModal) can
   know whether the tour is currently on a step that affects them
   WITHOUT importing the tour hook or threading the state through
   props.

   This is intentionally separate from `tour-event-bus.ts`: the bus
   fires one-shot events ("X happened"), this module exposes a
   continuous signal ("the tour is currently on step Y"). Locking the
   AddCustomerModal needs the continuous signal — a one-shot event
   would race with the modal mounting and might miss the locked state
   on mid-tour scenarios (e.g. Back from Step 4 to Step 3).

   Updated only by useTimesheetTour. Consumed only by components that
   need to react to specific tour steps (currently just the
   AddCustomerModal lock). */

let currentStepKey: string | null = null;
const listeners = new Set<() => void>();

export const setCurrentTourStepKey = (key: string | null): void => {
  if (currentStepKey === key) return;
  currentStepKey = key;
  Array.from(listeners).forEach((fn) => {
    try { fn(); } catch (_) { /* swallow — one bad listener can't break the rest */ }
  });
};

export const getCurrentTourStepKey = (): string | null => currentStepKey;

export const subscribeToTourStepKey = (fn: () => void): (() => void) => {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
};
